module.exports = __webpack_public_path__ + "img/biggame.0edff2f6.png";